import { render, staticRenderFns } from "./Cardresapending.vue?vue&type=template&id=4c400955&"
import script from "./Cardresapending.vue?vue&type=script&lang=js&"
export * from "./Cardresapending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports